import actions from './actions'

export default function WorkOrderInventoryServiceMapsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_WORKORDERINVENTORYSERVICEMAP:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_WORKORDERINVENTORYSERVICEMAP:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_WORKORDERINVENTORYSERVICEMAP:
      return {
        ...state,
        result: null,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_WORKORDERINVENTORYSERVICEMAP:
      return {
        ...state,
        editing: { workOrderInventoryServiceMapID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_WORKORDERINVENTORYSERVICEMAP_RECIEVED ||
      actions.UPDATE_WORKORDERINVENTORYSERVICEMAP_RECIEVED ||
      actions.DELETE_WORKORDERINVENTORYSERVICEMAP_RECIEVED:
      return {
        ...state,
        editing: { workOrderInventoryServiceMapID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    case actions.AMOUNT_UPDATED:
      return {
        ...state,
        amount: action.result,
        editing: { workOrderInventoryServiceMapID: 0 },
        loading: false,
      }
    default:
      return state
  }
}
